import { combineReducers, AnyAction } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { ThunkDispatch } from 'redux-thunk';

import servicesStructure from './ServicesStructureReducer';
import BookingRequestReducer from './BookingRequestReducer';
import EditJobRequestReducer from './EditJobRequestReducer';
import ClientDataReducer from './ClientDataReducer';
import ViewReducer from './ViewReducer';
import LoadingReducer from './LoadingReducer';
import FreelancersReducer from './freelancersReducer';
import unallocatedFreelancers from './unallocatedFreelancersReducer';
import ClientsReducer from './clientsReducer';
import UploadingFreelancersReducer from './uploadingFreelancersReducer';
import BookingsReducer from './bookingsReducer';
import sendSMSReducer from './sendSMSReducer';
import notificationsReducer from './notificationsReducer';
import payroll from './payrollReducer';
import calendar from './CalendarReducer';

import shifts from './ShiftsReducer';
import series from './SeriesReducer';
import subscriptions from './SubscriptionsReducer';
import tracking from './TrackingReducer';
import trackingMapReducer from './trackingMapReducer';

import job from './JobReducer';
import userReducer from './userReducer';

import AgentsReducer from './AgentsReducer';
import InductionSessionsReducer from './InductionSessionsReducer';

const rootReducer = combineReducers({
    servicesStructure,
    editJobRequestData: EditJobRequestReducer,
    requestData: BookingRequestReducer,
    clientData: ClientDataReducer,
    view: ViewReducer,
    loading: LoadingReducer,
    form: formReducer,
    freelancers: FreelancersReducer,
    unallocatedFreelancers,
    clients: ClientsReducer,
    uploadingFreelancers: UploadingFreelancersReducer,
    user: userReducer,
    sms: sendSMSReducer,
    bookings: BookingsReducer,
    trackingMap: trackingMapReducer,
    notifications: notificationsReducer,
    inductionSessions: InductionSessionsReducer,
    shifts,
    series,
    subscriptions,
    tracking,
    job,
    payroll,
    calendar,
    agents: AgentsReducer,
});

export default rootReducer;

export type TRootState = ReturnType<typeof rootReducer>;
export type TDispatch = ThunkDispatch<TRootState, void, AnyAction>;
